import { Table, TableBody, TableContainer } from "@mui/material";
import { FC, useMemo } from "react";

import { getTotalStakedAmount } from "../../../solana/common/helpers/user.dashboard.helpers";
import TableHeading from "../DashboardTable/TableHeading/TableHeading";
import { tableWrapper } from "../DashboardTable/TableHeading/TableHeading.styles";
import TableInfo from "../TableInfo/TableInfo";
import TableTitleAndFilters from "../TableTitleAndFilters/TableTitleAndFilters";
import StakingTableRow from "./StakingTableRow/StakingTableRow";
import totalStakedIcon from "../../../assets/totalStaked.svg";
import { StakingStatus } from "../../../common/enums/staking.enum";
import "./StakingTable.scss";
import useModifier from "../../../hooks/useModifier";
import { STAKING_TABLE_COLUMNS } from "../../../common/constants/dashboard.constants";
import { DashboardFilter } from "../../../common/enums/dashboard.enums";
import { dashboardStore } from "../../../contexts/dashboardStore";

const StakingTable: FC = () => {
  const { stakings } = dashboardStore();

  const { filteredItems, addFilterByName, addFilterItem } = useModifier(
    stakings ?? [],
    DashboardFilter.StakingStatus
  );

  const renderStakings = useMemo(() => {
    return filteredItems?.map((staking) => (
      <StakingTableRow
        stakingInfo={staking}
        key={staking.stakingAccountInfo.accountAddress.toString()}
      />
    ));
  }, [stakings, filteredItems]);

  return (
    <div className="staking-table">
      <div className="staking-table__info-cards">
        <TableInfo
          icon={totalStakedIcon}
          title="Total staked amount"
          description={`${getTotalStakedAmount(stakings).toString()} UNQ`}
        />
      </div>
      <TableTitleAndFilters
        filtersData={[
          {
            filterTitle: StakingStatus.FundingInitiated,
            onFilterSelect: () => {
              addFilterItem(StakingStatus.FundingInitiated);
            },
          },
          {
            filterTitle: StakingStatus.StakingInProgress,
            onFilterSelect: () => {
              addFilterItem(StakingStatus.StakingInProgress);
            },
          },
          {
            filterTitle: StakingStatus.StakingPeriodOver,
            onFilterSelect: () => {
              addFilterItem(StakingStatus.StakingPeriodOver);
            },
          },
        ]}
        tableTitle="List of your clubs' Staking Accounts"
      />
      <TableContainer style={tableWrapper}>
        <Table style={tableWrapper}>
          <TableHeading
            showInputField
            columns={STAKING_TABLE_COLUMNS}
            onInput={(e) => {
              addFilterByName(e.target.value);
            }}
          />
          <TableBody>{renderStakings}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default StakingTable;
